class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.responseEl = this.querySelector('.form-response');
    this.successMessage = this.getAttribute('success-message') || 'Message sent successfully!';
    this.errorMessage = this.getAttribute('error-message') || 'Something went wrong. Please try again.';
  }

  connectedCallback() {
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(e) {
    e.preventDefault();

    const btn = this.form.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.textContent = 'שולח...';
    this.responseEl.classList.add('d-none');
    this.responseEl.textContent = '';

    try {
      const formData = new FormData(this.form);



      const res = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      if (!res.ok) throw new Error('Network error');

      this.showResponse(this.successMessage, 'text-success');
      this.form.reset();
    } catch (err) {
      console.error('[ContactForm] Error:', err);
      this.showResponse(this.errorMessage, 'text-danger');
    } finally {
      btn.disabled = false;
      btn.textContent = this.form.dataset.submitLabel || 'שלח';
    }
  }

  showResponse(message, cssClass) {
    this.responseEl.textContent = message;
    this.responseEl.className = `form-response mt-3 ${cssClass}`;
    this.responseEl.classList.remove('d-none');
  }
}

customElements.define('contact-form', ContactForm);
